import type { HeaderAddress } from 'common/models';
import React from 'react';

interface OwnProps {
  address: HeaderAddress;
}

const AddressBlock = (props: OwnProps) => {
  const { address } = props;
  return (
    <div className="AddressBlock">
      <div>{address.street}</div>
      <div>{address.city}</div>
      <div>{address.postalCode}</div>
      {address.country && <div>{address.country}</div>}
    </div>
  );
};

export default AddressBlock;
